import { log } from 'cc';
import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import IHistoryDetailData from '../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryDetailData';
import IPlayResult from '../../../../../tableEngine/Script/Game/Data/DataObject/Play/IPlayResult';
// import NumberPrecision from 'number-precision';

export default class HistoryDetailData implements IHistoryDetailData {
    // public readonly betResults: { [betOptionIndex: number]: {} } = {};
    public readonly jackpotWin: number;
    public readonly jackpotContribution: number;

    public readonly bet: number;
    public readonly denom: number;
    public readonly result: IPlayResult;

    public readonly replayURL: string;
    public readonly replay: boolean;

    constructor(rawData: DataType.History.DetailData) {
        log('rawData', rawData);
        // this.jackpotWin = rawData.DeviceJPWin ?? 0;
        // this.jackpotContribution = (rawData.JPCtrbRatioBP ?? 0) / 10000;
        this.bet = rawData.TotalBet ?? 0;
        this.denom = rawData.Denom ?? 10000;
        // this.result = rawData.Result ?? null;
        // this.replayURL = rawData.ReplayURL ?? '';
        // this.replay = rawData.Replay ?? false;
    }
}
